import paper from 'paper';
import { createLayer } from './shared';
import store from '../store/store';

/**
 * Represents a Draw Action
 * @constructor
 * @param {Object} args - Layer, Tool, Points
 */
export class DrawAction {
    constructor(args) {
        this._args = args;
        // eslint-disable-next-line no-console
        // console.log('dispatching layer with name:', paper.project.layers[this._args.layer].exportJSON());
        store.dispatch('sendMessage', paper.project.layers[this._args.layer].exportJSON())
    }
    exec() {
        if (!paper.project.layers[this._args.layer]) {
            createLayer(this._args.layer);
        }
        if (this.removed) {
            // eslint-disable-next-line no-console
            console.log('this.removed',this.removed);
            
            return paper.project.layers[this._args.layer].addChildren(this.removed)
        }
    }
    importFromRemote(){
        // if (!paper.project.layers[this._args.layer]) {
        //     createLayer(this._args.layer);
        // }
        //  paper.project.layers[this._args.layer].addChildren(this.removed)
        
    }
    unexec() {
        this.removed = paper.project.layers[this._args.layer].removeChildren();
    }
}